var baseStyleCloseButton = {
  bg: '#1F1F1F',
  height: '2.125rem',
  px: 4,
  color: 'white',
  fontSize: 'md',
  fontWeight: 'bold',
  lineHeight: 'short',
  borderBox: 'box-sizing',
  _focus: {
    bg: '#FFD530',
    color: 'black',
    boxShadow: "0 0 0 0 rgba(31, 31, 31, 1)",
    outline: 'none',
    svg: {
      color: 'black'
    }
  },
  _hover: {
    bg: 'blue.600',
    color: 'white',
    svg: {
      color: 'white'
    }
  },
  svg: {
    color: 'white'
  }
};
export default {
  baseStyle: () => {
    return {
      dialog: {
        bg: 'grey.250',
        borderRadius: 'none'
      },
      closeButton: baseStyleCloseButton,
      header: {
        bg: '#363636',
        color: 'white',
        border: 'none'
      },
      footer: {
        bg: 'grey.250',
        borderColor: {
          base: 'grey.400',
          md: 'grey.1010'
        },
        borderTop: {
          base: '2px',
          md: '1px'
        },
        px: {
          base: 5,
          md: 8
        },
        py: 8
      },
      sizes: {
        full: {
          footer: {
            bg: 'grey.400'
          }
        }
      }
    };
  }
};